<template>
  <div class="c-info" v-if="compony">
    <p class="title">
      公司基本信息
    </p>
    <div class="base">
      <div class="img">
        <img :src="compony.img ? `${publicPath}images/${ compony.name }.jpg` : `${publicPath}images/logo-default.png`" alt="">
      </div>
      <span>{{ compony.name }}</span>
    </div>
    <ul class="list">
      <li>
        <i class="iconfont icon-ruanjian"></i>
        {{ compony.field }}
      </li>
      <li>
        <i class="iconfont icon-dianpu"></i>
        {{ compony.financing }}
      </li>
      <li>
        <i class="iconfont icon-team"></i>
        {{ compony.scale }}
      </li>
      <li>
        <i class="iconfont icon-zuobiao"></i>
        {{ compony.city }}
      </li>
      <li v-if="compony.web">
        <i class="iconfont icon-home"></i>
        {{ compony.web }}
      </li>
    </ul>
  </div>
</template>

<script>
import componys from '@/data.js'

export default {
  data () {
    return {
      compony: null
    }
  },
  created() {
    this.compony = componys[this.$route.params.id]
  }
}
</script>

<style lang="scss" scoped>
.c-info{
  width: 280px;
  .title{
    font-size: 16px;
    line-height: 20px;
    padding-bottom: 12px;
    border-bottom: 1px solid #F1F1F1;
    font-weight: 700;
  }
  .base{
    padding-top: 25px;
    display: flex;
    .img{
      background-color: #fff;
      background-image: url('../../../static/logo-default.png');
      background-size: cover;
      width: 60px;
      height: 60px;
      border-radius: 6px;
      border: 1px solid #E7E7E7;
      line-height: 60px;
      overflow: hidden;
      img{
        vertical-align: top;
        text-align: center;
        width: 100%;
        height: auto;
      }
    }
    span{
      line-height: 60px;
      margin-left: 15px;
      font-size: 16px;
      color: #000000;
    }
  }
  .list{
    li{
      margin-top: 12px;
      margin-bottom: 12px;
      line-height: 25px;
      font-size: 13px;
      color: #000000;
      vertical-align: middle;
      .iconfont{
        font-size: 25px;
        padding-left: 20px;
        color: #AEB1BB;
        margin-right: 34px;
        vertical-align: middle;
      }
    }
  }
}

@media (max-width: 768px){
  .c-info{
    width: 100%;
    padding: 0 15px;
    padding-top: 20px;
    border-top: 8px solid #F1F1F1;
    box-sizing: border-box;
    .title{
      font-size: 15px;
      line-height: 19px;
      margin-bottom: 20px;
      border: none;
      font-weight: 700;
      padding: 0;
    }
    .base{
      display: flex;
      margin: 0;
      padding: 0;
      .img{
        background-color: #fff;
        width: 55px;
        height: 55px;
        border-radius: 5px;
        border: 1px solid #E7E7E7;
        line-height: 55px;
        overflow: hidden;
        img{
          vertical-align: top;
          text-align: center;
          width: 100%;
          height: auto;
        }
      }
      span{
        line-height: 60px;
        margin-left: 15px;
        font-size: 16px;
        color: #000000;
      }
    }
    .list{
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 16px;
      li{
        min-width: 50%;
        margin-top: 8px;
        margin-bottom: 8px;
        line-height: 20px;
        font-size: 13px;
        color: #000000;
        vertical-align: middle;
        .iconfont{
          padding-left: 0;
          font-size: 20px;
          color: #AEB1BB;
          margin-right: 10px;
          vertical-align: middle;
        }
      }
    }
  }
}
</style>
